import { render, staticRenderFns } from "./productPeriodComponent.vue?vue&type=template&id=376a8575&scoped=true&"
import script from "./productPeriodComponent.vue?vue&type=script&lang=js&"
export * from "./productPeriodComponent.vue?vue&type=script&lang=js&"
import style0 from "./productPeriodComponent.vue?vue&type=style&index=0&id=376a8575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a8575",
  null
  
)

export default component.exports